import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {TemplateInfo} from "#template/interface-descriptors"
import {priorNodeClassChain} from "#template/versioning"
import {templateMarker} from "#template/nodes/template-graph/marker"
export {templateLikeMarker, isTemplateLikeNode, isTemplateLikeNodeClass, templateLike} from "#template/nodes/template-graph/marker"
export type {TemplateLikeNode} from "#template/nodes/template-graph/marker"
export const TemplateGraphFT = createFundamentalType({
    name: "TemplateGraph",
    marker: templateMarker,
    InfoClass: TemplateInfo,
    icon: "far fa-diagram-project",
})

// FT renamed `Template` → `TemplateGraph`; versionChain entries keep saved `Template*` graphs deserializing.
@registerFundamentalNode(TemplateGraphFT, "Likes")
export class TemplateGraphLikes extends TemplateGraphFT.Likes {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("TemplateLikes")}
    }
}

@registerFundamentalNode(TemplateGraphFT, "Switch")
export class TemplateGraphSwitch extends TemplateGraphFT.Switch {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("TemplateSwitch")}
    }
}

@registerFundamentalNode(TemplateGraphFT, "Input")
export class TemplateGraphInput extends TemplateGraphFT.Input {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("TemplateInput")}
    }
}

@registerFundamentalNode(TemplateGraphFT, "Output")
export class TemplateGraphOutput extends TemplateGraphFT.Output {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("TemplateOutput")}
    }
}

@registerFundamentalNode(TemplateGraphFT, "Export")
export class TemplateGraphExport extends TemplateGraphFT.Export {
    public override get definition() {
        return {...super.definition, versionChain: priorNodeClassChain("TemplateExport")}
    }
}
